// Funcionalidad de drag para carruseles de producto en desktop
document.addEventListener('DOMContentLoaded', function() {
  // Solo en desktop
  if (window.innerWidth < 750) return;
  
  const carousels = document.querySelectorAll('.product-card__carousel');
  
  carousels.forEach(function(carousel) {
    const track = carousel.querySelector('.carousel-track');
    if (!track) return;
    
    const slides = track.querySelectorAll('.carousel-slide');
    const indicators = carousel.querySelectorAll('.indicator');
    if (slides.length < 2) return;
    
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let currentSlide = 0;
    let startTransform = 0;
    let hasMoved = false;
    
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'none';
    carousel.style.webkitUserSelect = 'none';
    
    // Función para actualizar indicadores
    function updateIndicators(index) {
      indicators.forEach((ind, i) => {
        ind.classList.toggle('active', i === index);
      });
    }
    
    carousel.addEventListener('mousedown', function(e) {
      // No activar drag si se hace click en los indicadores
      if (e.target.closest('.carousel-indicators')) {
        return;
      }
      
      isDragging = true;
      startX = e.pageX;
      hasMoved = false;
      carousel.style.cursor = 'grabbing';
      
      // Obtener el slide actual del transform
      const transform = track.style.transform || 'translateX(0%)';
      const match = transform.match(/translateX\((-?\d+)%\)/);
      const transformValue = match ? parseInt(match[1]) : 0;
      currentSlide = Math.abs(transformValue / 100);
      startTransform = transformValue;
      
      track.style.transition = 'none';
      e.preventDefault();
    });
    
    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      
      currentX = e.pageX;
      const diff = currentX - startX;
      
      if (Math.abs(diff) > 5) {
        hasMoved = true;
      }
      
      const percentage = (diff / carousel.offsetWidth) * 100;
      track.style.transform = `translateX(${startTransform + percentage}%)`;
    });
    
    document.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      
      isDragging = false;
      carousel.style.cursor = 'grab';
      
      const diff = currentX - startX;
      const threshold = 50;
      
      track.style.transition = 'transform 0.3s ease-out';
      
      if (diff > threshold && currentSlide > 0) {
        currentSlide--;
      } else if (diff < -threshold && currentSlide < slides.length - 1) {
        currentSlide++;
      }
      
      track.style.transform = `translateX(-${currentSlide * 100}%)`;
      updateIndicators(currentSlide);
      
      currentX = 0;
    });
    
    // Prevenir click en links si hubo drag
    carousel.addEventListener('click', function(e) {
      if (e.target.closest('.carousel-indicators')) {
        return;
      }
      
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    
    // Prevenir drag de imágenes
    carousel.addEventListener('dragstart', function(e) {
      e.preventDefault();
    });
  });
});
